import styled from 'styled-components';

export const IconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    width: ${p => p.iconWidth ? p.iconWidth : ''};
    height: ${p => p.iconHeight ? p.iconHeight : ''};
    margin: ${p => p.margin ? p.margin : ''};
    flex-shrink: 0;
    > svg{
        width: 100%;
    }
`;

export const DefaultIcon= styled.span`
    width: 1.6rem;
    height: 1.6rem;
    background-color: #9b9b9b;
    border-radius: 50%;
    display: inline-flex;
`
